import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Menu, Icon } from 'antd';
import download from 'downloadjs/download';

import { copyCutFile } from 'actions/copyFile';
import { setChangedBrowserDataWhenAdd, setChangedBrowserDataWhenDelete } from 'actions';
import { selectElements } from 'actions/selectedElement';
import { setFileContent } from 'actions';
import FolderModalForm from './folderModalForm';
import FileModalForm from './fileModalForm';
import { showDeleteFileModal } from 'helpers/deleteFilesModal';
import UploadModal from './uploadModal';
import RenameModal from './renameFileModal';
import { toastError, toastInfo, toastSuccess } from 'utils/toastr';
import handlePasteClick from 'helpers/handlePasteClick';
import requestAPI from 'helpers/requestAPI';

import './controlPanel.scss';

const ControlPanel = ({
	site_id,
	selectedElementsName,
	copyCutFile,
	copyFileData,
	directory,
	setChangedBrowserDataWhenAdd,
	setChangedBrowserDataWhenDelete,
	filesTree,
	fileContent
}) => {
	const [ visibleFileModal, setVisibleFileModal ] = useState(false);
	const [ visibleFolderMolder, setVisibleFolderModal ] = useState(false);
	const [ visibleRenameModal, setVisibleRenameModal ] = useState(false);
	const [ visibleUploadModal, setVisibleUploadModal ] = useState(false);

	const changeVisible = () => {
		setVisibleFileModal(false);
		setVisibleFolderModal(false);
		setVisibleRenameModal(false);
		setVisibleUploadModal(false);
	};

	const handleFileClick = () => {
		if (!site_id) {
			toastInfo('Please select a site to create the file', 'Hey!');
			return;
		}

		setVisibleFileModal(!visibleFileModal);
	};

	const handleFolderClick = () => {
		if (!site_id) {
			toastInfo('Please select a site to create the folder', 'Hey!');
			return;
		}

		setVisibleFolderModal(!visibleFolderMolder);
	};

	const handleEditFileClick = (e) => {
		const selectedElementsLength = selectedElementsName.selectedElements.length;
		const isFolder = selectedElementsLength > 0 && selectedElementsName.selectedElements[0].isFolder;

		if (selectedElementsLength > 1) {
			toastError('Select one file', 'Error');
			e.preventDefault();
		}

		if (isFolder) {
			toastError('You select folder, please select file', 'Error');
			e.preventDefault();
		}

		if (selectedElementsLength > 0 && !isFolder) {
			const params = {
				routeParams: {
					route: 'file'
				},
				additionalQueryStringParams: {
					site_id: selectedElementsName.siteId,
					directory: selectedElementsName.directory,
					filename: selectedElementsName.selectedElements[0].name
				}
			};

			requestAPI(params)
				.then((response) => {
					fileContent(response.data);
				})
				.catch((error) => {
					console.log(error);
				});
		}
	};

	const handleCopyClick = () => {
		if (!selectedElementsName.selectedElements.length) {
			toastInfo('Nothing to copy!', 'Hmmm...');
			return;
		}
		if (selectedElementsName.selectedElements.length > 1) {
			toastError('Only one file can be copied', 'Error');
			return;
		}

		const filename = selectedElementsName.selectedElements[0].name;

		copyCutFile({
			name: filename,
			data: '',
			directory,
			isFolder: selectedElementsName.selectedElements[0].isFolder,
			action: 'copy',
			siteName: filesTree[0].siteName
		});
	};

	const handleCutClick = () => {
		if (!selectedElementsName.selectedElements.length) {
			toastInfo('Nothing to cut!', 'Hmmm...');
			return;
		}
		if (selectedElementsName.selectedElements.length > 1) {
			toastError('Only one file or folder can be cuted', 'Error');
			return;
		}

		const filename = selectedElementsName.selectedElements[0].name;

		copyCutFile({
			name: filename,
			data: '',
			directory,
			isFolder: selectedElementsName.selectedElements[0].isFolder,
			action: 'cut',
			siteName: filesTree[0].siteName
		});
	};

	const handleUploadClick = () => {
		if (!site_id) {
			toastInfo('Please select a site before uploading a file', 'Hey!');
			return;
		}

		setVisibleUploadModal(!visibleUploadModal);
	};

	const handleDeleteClick = () => {
		if (!selectedElementsName.selectedElements.length) {
			toastInfo('Nothing to delete!', 'Hmmm...');
			return;
		}

		showDeleteFileModal(selectedElementsName, setChangedBrowserDataWhenDelete, selectElements, site_id, directory);
	};

	const handleDownloadClick = () => {
		if (selectedElementsName.selectedElements.length > 1) {
			toastError('Only one file or folder can be downloaded', 'Error');
			return;
		}
		if (selectedElementsName.selectedElements.length) {
			const deleteTemp = (path) => {
				const params = {
					routeParams: {
						route: 'file_upload'
					},
					method: 'DELETE',
					data: {
						path
					}
				};

				requestAPI(params).then((res) => {
					console.log(res);
				});
			};

			let params = {};

			if (selectedElementsName.selectedElements[0].isFolder) {
				const path = directory
					? directory + '/' + selectedElementsName.selectedElements[0].name
					: selectedElementsName.selectedElements[0].name;

				params = {
					routeParams: {
						route: 'dir_upload'
					},
					additionalQueryStringParams: {
						site_id,
						directory: path
					}
				};
			} else {
				params = {
					routeParams: {
						route: 'file_upload'
					},
					additionalQueryStringParams: {
						site_id,
						directory,
						filename: selectedElementsName.selectedElements[0].name
					}
				};
			}

			requestAPI(params).then((response) => {
				if (response.data.ms === 'Ошибка' || response.status !== 200) {
					toastError(response.data.ms, 'Error');
				} else {
					const params = {
						routeParams: {
							route: response.data.data
						},
						withoutApiInEnd: true,
						blobDownload: true
					};

					requestAPI(params).then((resp) => {
						console.log(resp.data)
						download(resp.data, selectedElementsName.selectedElements[0].name);
						setTimeout(() => deleteTemp(response.data.data), 15000);
					});
				}
			});
		}
	};

	const handleBackupClick = () => {
		if (!selectedElementsName.selectedElements.length) return;
		if (selectedElementsName.selectedElements.length > 1) {
			toastError('Only one folder can be backuped', 'Error');
			return;
		}
		if (!selectedElementsName.selectedElements[0].isFolder) {
			toastError('Only folders can be backuped');
			return;
		}

		const path = directory
					? directory + '/' + selectedElementsName.selectedElements[0].name
					: selectedElementsName.selectedElements[0].name;

		const params = {
			routeParams: {
				route: 'dir_upload'
			},
			method: 'PUT',
			additionalQueryStringParams: {
				site_id,
				directory: path
			}
		};

		requestAPI(params).then(() => {
			toastSuccess('Folder has been backuped!');
		}).catch(err => {
			toastError(err);
		});
	}

	const handleRenameClick = () => {
		if (selectedElementsName.selectedElements.length > 1) {
			toastError('Only one file or folder can be renamed!', 'Error');
			return;
		}
		if (!selectedElementsName.selectedElements.length) {
			toastInfo('Please select a file what you want to rename!', 'Hmmm...');
			return;
		}

		setVisibleRenameModal(!visibleRenameModal);
	};

	const itemsArray = [
		{
			name: 'File',
			icon: 'file-add',
			onClick: handleFileClick,
			modal: <FileModalForm visible={visibleFileModal} changeVisible={changeVisible} />
		},
		{
			name: 'Folder',
			icon: 'folder-add',
			onClick: handleFolderClick,
			modal: <FolderModalForm visible={visibleFolderMolder} changeVisible={changeVisible} />
		},
		{
			name: 'Edit file',
			icon: 'edit',
			customNode: (
				<Menu.Item key="control-panel-item__link__edit">
					<Link className="control-panel-item__link" onClick={(e) => handleEditFileClick(e)} to="/editor">
						<Icon type="edit" />
						File editor
					</Link>
				</Menu.Item>
			)
		},
		{
			name: 'Copy',
			icon: 'copy',
			onClick: handleCopyClick
		},
		{
			name: 'Cut',
			icon: 'scissor',
			onClick: handleCutClick
		},
		{
			name: 'Paste',
			icon: 'snippets',
			onClick: () => handlePasteClick(copyFileData, site_id, directory, setChangedBrowserDataWhenAdd, filesTree)
		},
		{
			name: 'Upload',
			icon: 'upload',
			onClick: handleUploadClick,
			modal: <UploadModal visible={visibleUploadModal} changeVisible={changeVisible} />
		},
		{
			name: 'Download',
			icon: 'download',
			onClick: handleDownloadClick
		},
		{
			name: 'Delete',
			icon: 'delete',
			onClick: handleDeleteClick
		},
		{
			name: 'Rename',
			icon: 'highlight',
			onClick: handleRenameClick,
			modal: <RenameModal visible={visibleRenameModal} changeVisible={changeVisible} />
		},
		{
			name: 'Backup',
			icon: 'rollback',
			onClick: handleBackupClick
		}
	];

	return (
		<div>
			<Menu theme="dark" mode="horizontal" selectable={false} className="control-panel">
				{itemsArray.map(
					(listItem) =>
						listItem.customNode || (
							<Menu.Item key={listItem.name} onClick={listItem.onClick}>
								<Icon type={listItem.icon} />
								{listItem.name}
							</Menu.Item>
						)
				)}
			</Menu>
			<ul style={{ display: 'none' }}>{itemsArray.map((items, i) => <li key={i}>{items.modal}</li>)}</ul>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		site_id: state.selectedElement.siteId,
		directory: state.selectedElement.directory,
		selectedElementsName: state.selectedElement,
		copyFileData: state.copyFile.copyFileData,
		filesTree: state.files.browserData
	};
};

const mapDispatchToProps = (dispatch) => ({
	copyCutFile: (data) => dispatch(copyCutFile(data)),
	setChangedBrowserDataWhenAdd: (data) => dispatch(setChangedBrowserDataWhenAdd(data)),
	setChangedBrowserDataWhenDelete: (data) => dispatch(setChangedBrowserDataWhenDelete(data)),
	selectElements: (data) => dispatch(selectElements(data)),
	fileContent: (data) => dispatch(setFileContent(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ControlPanel);